import {
  VARIANTS,
  COBRANDED_LIGHT_REGULAR_STYLES,
  TextComponentType,
} from '@openbank/ziniaweb-ui-components';

const SUCCESS_FOOTER_PROPS = {
    variant: VARIANTS.FooterVariantsType.ONE_ACTION,
  },
  SUCCESS_FOOTER_BUTTON_PROPS = {
    size: VARIANTS.ButtonSizeType.LARGE,
    type: VARIANTS.ButtonVariantType.PRIMARY,
  },
  SUCCESS_TITLE_PROPS = {
    component: TextComponentType.H1,
    customTypography: {
      font_family: COBRANDED_LIGHT_REGULAR_STYLES.font_family_heading,
      font_size: COBRANDED_LIGHT_REGULAR_STYLES.font_size_heading_xllm_h,
      font_weight: COBRANDED_LIGHT_REGULAR_STYLES.font_weight_heading_xllm_h_bold,
      line_height: COBRANDED_LIGHT_REGULAR_STYLES.font_line_height_heading_xllm_h,
      color: COBRANDED_LIGHT_REGULAR_STYLES.color_neutral_font_50,
    },
    showBuilder: false,
    testId: 'success-container-title',
  },
  SUCCESS_SUBTITLE_PROPS = {
    component: TextComponentType.H2,
    customTypography: {
      font_family: COBRANDED_LIGHT_REGULAR_STYLES.font_family_heading,
      font_size: COBRANDED_LIGHT_REGULAR_STYLES.font_size_heading_xllm_h2,
      font_weight: COBRANDED_LIGHT_REGULAR_STYLES.font_weight_heading_xllm_h2_regular,
      line_height: COBRANDED_LIGHT_REGULAR_STYLES.font_line_height_heading_xllm_h2,
      color: COBRANDED_LIGHT_REGULAR_STYLES.color_neutral_font_50,
    },
    showBuilder: false,
    testId: 'success-container-subtitle',
  };

export {
  SUCCESS_FOOTER_BUTTON_PROPS,
  SUCCESS_FOOTER_PROPS,
  SUCCESS_SUBTITLE_PROPS,
  SUCCESS_TITLE_PROPS,
};
